import * as types from './examDataActionType';

//Exam Data - start
export const fetchExamDataRequest = (data, meta = {}) => ({
    type: types.FETCH_EXAM_DATA_REQUEST,
    payload: data,
    meta
});

export const fetchExamDataSuccess = (data, meta = {}) => ({
    type: types.FETCH_EXAM_DATA_SUCCESS,
    payload: data,
    meta
});

export const fetchExamDataFailure = (error, meta = {}) => ({
    type: types.FETCH_EXAM_DATA_FAILURE,
    payload: error,
    meta
});

export const invalidateExamDataCache = () => ({
    type: types.INVALIDATE_EXAM_DATA_CACHE
});

export const clearExamData = () => ({
    type: types.CLEAR_EXAM_DATA
});

export const fetchRecalculateDataRequest = () => ({
    type: types.FETCH_RECALCULATE_DATA_REQUEST,
});

export const fetchRecalculateDataSuccess = (data) => ({
    type: types.FETCH_RECALCULATE_DATA_SUCCESS,
    payload: data
});
export const fetchRecalculateDataFailure = (error) => ({
    type: types.FETCH_RECALCULATE_DATA_FAILURE,
    payload: error
});


//Exam Data Dropdown Options - start
export const fetchExamDropdownOptionsRequest = (payload) => ({
    type: types.FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST,
    payload
});

export const fetchExamDropdownOptionsSuccess = (data) => ({
    type: types.FETCH_EXAM_DROPDOWN_OPTIONS_SUCCESS,
    payload: data
});

export const fetchExamDropdownOptionsFailure = (error) => ({
    type: types.FETCH_EXAM_DROPDOWN_OPTIONS_FAILURE,
    payload: error
});
//Exam Data Dropdown Options - end

// Exam data record date

export const updateExamDataRecordDateRequest = (payload) => ({
    type: types.UPDATE_EXAM_DATA_RECORD_DATE_REQUEST,
    payload
});
export const updateExamDataRecordDateSuccess = (data) => ({
    type: types.UPDATE_EXAM_DATA_RECORD_DATE_SUCCESS,
    payload: data
});

export const updateExamDataRecordDateFailure = (error) => ({
    type: types.UPDATE_EXAM_DATA_RECORD_DATE_FAILURE,
    payload: error
});

export const refreshRawExamDataRequest = (fromDate, toDate, userId) => ({
    type: types.REFRESH_RAW_EXAM_DATA_REQUEST,
    payload: { fromDate, toDate, userId }
});
export const refreshRawExamDataSuccess = (data) => ({
    type: types.REFRESH_RAW_EXAM_DATA_SUCCESS,
    payload: data
});
export const refreshRawExamDataFailure = (error) => ({
    type: types.REFRESH_RAW_EXAM_DATA_FAILURE,
    payload: error
});

export const saveBatchRecordExamDataRequest = (ID) => ({
    type: types.SAVE_BATCH_RECORD_EXAM_DATA_REQUEST,
    payload: { ID }
});
export const saveBatchRecordExamDataSuccess = (data) => ({
    type: types.SAVE_BATCH_RECORD_EXAM_DATA_SUCCESS,
    payload: data
});
export const saveBatchRecordExamDataFailure = (error) => ({
    type: types.SAVE_BATCH_RECORD_EXAM_DATA_FAILURE,
    payload: error
});

//Get batch by record date
export const fetchExamDataBatchRequest = (recordDate) => ({
    type: types.FETCH_EXAM_DATA_BATCH_REQUEST,
    payload: { recordDate }
});
export const fetchExamDataBatchSuccess = (data) => ({
    type: types.FETCH_EXAM_DATA_BATCH_SUCCESS,
    payload: data
});
export const fetchExamDataBatchFailure = (error) => ({
    type: types.FETCH_EXAM_DATA_BATCH_FAILURE,
    payload: error
});

// Save Batch Record
export const saveBatchRecordRequest = (payload) => ({
    type: types.SAVE_BATCH_RECORD_REQUEST,
    payload
});
export const saveBatchRecordSuccess = (data) => ({
    type: types.SAVE_BATCH_RECORD_SUCCESS,
    payload: data
});
export const saveBatchRecordFailure = (error) => ({
    type: types.SAVE_BATCH_RECORD_FAILURE,
    payload: error
});

// Check Recalculation
export const checkRecalculationRequest = () => ({
    type: types.CHECK_RECALCULATION_REQUEST,
});
export const checkRecalculationSuccess = (data) => ({
    type: types.CHECK_RECALCULATION_SUCCESS,
    payload: data
});
export const checkRecalculationFailure = (error) => ({
    type: types.CHECK_RECALCULATION_FAILURE,
    payload: error
});

//Re Calculate Exam Data Details

export const reCalculateExamDataDetailsRequest = (payload) => ({
    type: types.RE_CALCULATE_EXAM_DATA_DETAILS_REQUEST,
    payload
});

export const reCalculateExamDataDetailsSuccess = (data) => ({
    type: types.RE_CALCULATE_EXAM_DATA_DETAILS_SUCCESS,
    payload: data
});

export const reCalculateExamDataDetailsFailure = (error) => ({
    type: types.RE_CALCULATE_EXAM_DATA_DETAILS_FAILURE,
    payload: error
});

export const resetCheckRecalculation = () => ({
    type: types.RESET_CHECK_RECALCULATION
});

// Get Unassigned Combinations
export const fetchUnassignedCombinationsRequest = (payload) => ({
    type: types.FETCH_UNASSIGNED_COMBINATIONS_REQUEST,
    payload
});

export const fetchUnassignedCombinationsSuccess = (data) => ({
    type: types.FETCH_UNASSIGNED_COMBINATIONS_SUCCESS,
    payload: data
});

export const fetchUnassignedCombinationsFailure = (error) => ({
    type: types.FETCH_UNASSIGNED_COMBINATIONS_FAILURE,
    payload: error
});

// Check Worklist Assignments
export const checkWorklistAssignmentsRequest = (payload) => ({
    type: types.CHECK_WORKLIST_ASSIGNMENTS_REQUEST,
    payload
});

export const checkWorklistAssignmentsSuccess = (data) => ({
    type: types.CHECK_WORKLIST_ASSIGNMENTS_SUCCESS,
    payload: data
});

export const checkWorklistAssignmentsFailure = (error) => ({
    type: types.CHECK_WORKLIST_ASSIGNMENTS_FAILURE,
    payload: error
});

// Save Worklist Mapping
export const saveWorklistMappingRequest = (payload) => ({
    type: types.SAVE_WORKLIST_MAPPING_REQUEST,
    payload
});

export const saveWorklistMappingSuccess = (data) => ({
    type: types.SAVE_WORKLIST_MAPPING_SUCCESS,
    payload: data
});

export const saveWorklistMappingFailure = (error) => ({
    type: types.SAVE_WORKLIST_MAPPING_FAILURE,
    payload: error
});

export const saveWorklistMappingUpdateRequest = (payload) => ({
    type: types.SAVE_WORKLIST_MAPPING_UPDATE_REQUEST,
    payload
});

export const saveWorklistMappingUpdateSuccess = (data) => ({
    type: types.SAVE_WORKLIST_MAPPING_UPDATE_SUCCESS,
    payload: data
});

export const saveWorklistMappingUpdateFailure = (error) => ({
    type: types.SAVE_WORKLIST_MAPPING_UPDATE_FAILURE,
    payload: error
});

// Get Unassigned Exam Data Count (tab badge)
export const fetchUnassignedExamDataCountRequest = (payload) => ({
    type: types.FETCH_UNASSIGNED_EXAM_DATA_COUNT_REQUEST,
    payload
});

export const fetchUnassignedExamDataCountSuccess = (data) => ({
    type: types.FETCH_UNASSIGNED_EXAM_DATA_COUNT_SUCCESS,
    payload: data
});

export const fetchUnassignedExamDataCountFailure = (error) => ({
    type: types.FETCH_UNASSIGNED_EXAM_DATA_COUNT_FAILURE,
    payload: error
});

// Export Calculated Exam Data To CSV
export const exportCalculatedExamDataToCSVRequest = (payload) => ({
    type: types.EXPORT_CALCULATED_EXAM_DATA_REQUEST,
    payload
});

export const exportCalculatedExamDataToCSVSuccess = () => ({
    type: types.EXPORT_CALCULATED_EXAM_DATA_SUCCESS
});

export const exportCalculatedExamDataToCSVFailure = (error) => ({
    type: types.EXPORT_CALCULATED_EXAM_DATA_FAILURE,
    payload: error
});

//Exam Data - end